const routeConfig = require('./route-config');
const Token = require('common/lib/util/token').default;
const md5 = require('blueimp-md5');
const history = require('common/history').default;

/*
  This method replicates the private routing logic in Backbone.js
 */
const routeToRegexp = function(route) {
  const routeStr = route
    // eslint-disable-next-line no-useless-escape
    .replace(/[\-{}\[\]+?.,\\\^$|#\s]/g, '\\$&')
    .replace(/\((.*?)\)/g, '(?:$1)?')
    .replace(/(\(\?)?:\w+/g, function(match, optional) {
      return optional ? match : '([^/?]+)';
    })
    .replace(/\*\w+/g, '([^?]*?)');

  return new RegExp(`^${routeStr}(?:\\?([\\s\\S]*))?$`);
};

export default new class Interceptor {
  controllerRef = null;
  gammaRef = null;
  compiledConfig = routeConfig.map((config) => {
    return {
      ...config,
      match: (config.match || []).map(routeToRegexp),
    };
  });

  setController(controller) {
    this.controllerRef = controller;
  }

  setGamma(gamma) {
    this.gammaRef = gamma;
  }

  hideGamma() {
    $('#root').css({ display: 'none' });

    if (!this.gammaRef) {
      return;
    }

    this.gammaRef.unmount();
    this.gammaRef = null;
  }

  navigateToGamma(path, state) {
    $('.header-logo').addClass('is-throbbing');
    this.controllerRef.clearPreviousView(true);
    history.push(path, state);
  }

  navigateToClassic() {
    this.controllerRef.clearPreviousView();
  }

  isGammaRoute(path) {
    const config = this.compiledConfig.find((conf) =>
      conf.match.find((rxp) => rxp.test(path)),
    );

    if (config) {
      const { audience, allocation, name } = config;

      const override = localStorage.getItem('routeConfig');
      if (override) {
        const overrides = override.split(',').map((a) => a.trim());
        if (overrides.includes(name)) {
          return true;
        }
      }

      if (audience) {
        const audiences = Array.isArray(audience) ? audience : [audience];
        const matchesAll = audiences.every(() => {
          if (audience === 'notLoggedIn') {
            return !Token.getMyId();
          } else {
            console.error(
              `Unknown audience in single-spa interceptor: ${audience}`,
            );

            return false;
          }
        });
        if (!matchesAll) {
          return false;
        }
      }

      if (allocation) {
        const myId = Token.getMyId() || 'notLoggedIn';
        const bucket =
          parseInt(md5(`${name}for${myId}`).slice(0, 8), 16) % 1000;

        return bucket <= allocation * 1000;
      }
    }

    return false;
  }
}();



// WEBPACK FOOTER //
// ./app/scripts/singlespa/interceptor.js